var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'header-top': _vm.isListingPages()},attrs:{"id":"wrapper"}},[_c('app-header'),_c('router-view'),(_vm.isFooter)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }